// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"cf6dfb26","865":"6cd6b777"}[chunkId] + ".chunk.js";
};